export const enum NotPlannedTaskLabel {
  plan_pass_fail_type = 'Not Planned',
  percentage_progress_type = 'Not Planned',
  plan_submit_approve_reject_type = 'Not Planned',
  plan_done_type = 'Not Planned',
  plan_inprogress_done_type = 'Not Start',
}

export enum status {
  active = 'active',
  inactive = 'inactive',
  archive = 'archive',
}

export enum order_status {
  new = 'new',
  in_progress = 'in_progress',
  completed = 'completed',
}

export enum user_type {
  owner = 'owner',
  guest = 'guest',
}

// task progess
export enum progress_status {
  new = 'new',
  not_start = 'not_start',
  done = 'done',
  in_progress = 'in_progress',
}

export enum comment_type {
  new = 'new',
  reply = 'reply',
  chat = 'chat',
}

export enum task_type {
  plan_submit_approve_reject_type = 'plan_submit_approve_reject_type',
  plan_pass_fail_type = 'plan_pass_fail_type',
  plan_inprogress_done_type = 'plan_inprogress_done_type',
  percentage_progress_type = 'percentage_progress_type',
  production_status_type = 'production_status_type',
  plan_done_type = 'plan_done_type',
}

export enum task_status {
  start = 'start',
  in_progress = 'in_progress',
  finish = 'finish',
}
